<template>
  <div class="page">
        <!-- 搜索 -->
  <el-form v-if="isSearch" :model="queryForm" ref="form" label-width="90px" :inline="true" size="small" class="query-form" @submit.native.prevent>
              <el-form-item label="客服">
<!--                  <el-input  v-model="queryForm.customerId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="customerName"
                               labelValue="id" title="选择客服" :value="queryForm.customerId" :limit='1' size='small' placeholder='请选择客服'
                               @getValue="getSearchValueUser" :columns="CUSTOMER_code" :searchs="CUSTOMER_search" dataListUrl="/im/webimcustomer/findList" entityBeanName="imWebimCustomer" queryEntityUrl="/im/webimcustomer/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="坐席用户">
<!--                  <el-input  v-model="queryForm.userId"></el-input>-->
                  <GridSelectU style="width: 177px;" labelName="userName"
                               labelValue="id" title="选择用户" :value="queryForm.userId" :limit='1' size='small' placeholder='请选择用户'
                               @getValue="getSearchValueUser1" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
                  </GridSelectU>
              </el-form-item>
              <el-form-item label="托管给系统">
<!--                  <el-input style="width: 177px;" v-model="queryForm.aiCustomer"></el-input>-->
                  <el-select
                      size="small"
                      style="width: 177px;"
                      clearable
                      v-model="queryForm.aiCustomer"
                  >
                      <el-option
                          label="是"
                          :value="1"
                      ></el-option>
                      <el-option
                          label="否"
                          :value="0"
                      ></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item>
                  <el-button size="small" type="primary" icon="el-icon-search" @click="getImWebimSeatList">查询</el-button>
                  <el-button size="small" icon="el-icon-refresh" @click="resetDialog">重置</el-button>
              </el-form-item>
  </el-form>
  <div class="page-content">
    <div class="page-tool-bar">
      <div class="el-btn-group">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="addImWebimSeat"
        >新建</el-button>
        <el-button
          type="warning"
          plain
          size="small"
          icon="el-icon-edit"
          :disabled="multipleSelection.length != 1"
          @click="editImWebimSeat(null)"
        >修改</el-button>
        <el-button
          type="danger"
          plain
          size="small"
          icon="el-icon-delete"
          :disabled="multipleSelection.length <= 0"
          @click="deleteImWebimSeat(null)"
        >删除</el-button>
      </div>

      <div class="icon-group">
            <el-upload v-if="this.isImportDate"
              class="upload-demo"
              action="#"
                            :http-request="upload"
              :show-file-list="true">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只允许导入“xls”或“xlsx”格式文件！</div>
            </el-upload>
        <span
          title="搜索"
          class="icon-box"
          @click="search"
        >
          <Icon color="#606266">
            <Search />
          </Icon>
        </span>
        <span
          class="icon-box"
          @click="refreshImWebimSeatList"
        >
          <Icon color="#606266">
            <Refresh />
          </Icon>
        </span>
      </div>
    </div>
          <!-- 列表数据 -->
    <el-table
      :data="imWebimSeatList"
      row-key="id"
      border
      height="100%"
      :header-row-style="{height: '10px'}"
      :header-cell-style="{padding: '10px'}"
      :row-style="{height: '9px'}"
      :cell-style="{padding: '9px'}"
      @selection-change="handleSelectionChange"
      size="small"
    >
      <el-table-column
        align="center"
        type="selection"
        width="60"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="customerId"
        label="客服"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="userId"
        label="坐席用户"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="greeting"
        label="问候语"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="aiCustomer"
        label="托管给系统"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="sort"
        label="排序"
        width="180"
      > </el-table-column>
      <el-table-column
        :show-overflow-tooltip="true"
        align="center"
        prop="createTime"
        label="创建时间"
        width="180"
      > </el-table-column>
      <el-table-column
        fixed="right"
        align="center"
        label="操作"
        width="300"
      >
        <template slot-scope="scop">
          <div class="operation">
            <div @click="checkImWebimSeat(scop.row.id)">
              <Icon size="16">
                <Eye24Regular />
              </Icon>
              <span class="operation-label">查看</span>
            </div>
            <div @click="editImWebimSeat(scop.row.id)">
              <Icon size="16">
                <Edit24Regular />
              </Icon>
              <span class="operation-label">修改</span>
            </div>
            <div @click="deleteImWebimSeat(scop.row.id)">
              <Icon size="16" style="color: red">
                <Delete24Regular />
              </Icon>
              <span class="operation-label" style="color: red">删除</span>
            </div>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-box">
      <el-pagination
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page.sync="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalNum"
        background
        :pager-count="7"
      >
      </el-pagination>
    </div>
    <!-- 新增/查看/修改信息 -->
    <el-dialog
      :title="imWebimSeatStates[imWebimSeatState]"
      :visible.sync="showDialog"
      width="60%"
      @close="closeDialog"
    >
      <div>
        <el-form
          :model="imWebimSeat"
          ref="imWebimSeatForm"
          :rules="rules"
          label-width="120px"
          :inline="true"
          size="small"
        >
          <el-form-item
            label="客服"
            prop="customerId"
            v-if="isSa==1"
          >
            <!-- <el-input
              size="small"
              v-model="imWebimSeat.customerId"
              :disabled="imWebimSeatState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" labelName="customerName" :disabled="imWebimSeatState == 'check'"
                labelValue="id" title="选择客服" :value="imWebimSeat.customerId" :limit='1' size='small' placeholder='请选择客服'
                @getValue="getValueUser" :columns="CUSTOMER_code" :searchs="CUSTOMER_search" dataListUrl="/im/webimcustomer/findList" entityBeanName="imWebimCustomer" queryEntityUrl="/im/webimcustomer/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="坐席用户"
            prop="userId"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimSeat.userId"
              :disabled="imWebimSeatState == 'check'"
            ></el-input> -->
            <GridSelectU style="width: 177px;" labelName="userName" :disabled="imWebimSeatState == 'check'"
                labelValue="id" title="选择用户" :value="imWebimSeat.userId" :limit='1' size='small' placeholder='请选择用户'
                @getValue="getValueUser1" :columns="USER_code" :searchs="USER_search" dataListUrl="/mpp/user/findList" entityBeanName="mppUser" queryEntityUrl="/mpp/user/get">
              </GridSelectU>
          </el-form-item>
          <el-form-item
            label="问候语"
            prop="greeting"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimSeat.greeting"
              :disabled="imWebimSeatState == 'check'"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="托管给系统"
            prop="aiCustomer"
          >
            <!-- <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimSeat.aiCustomer"
              :disabled="imWebimSeatState == 'check'"
            ></el-input> -->
            <el-select
              size="small"
              style="width: 177px;"
              v-model="imWebimSeat.aiCustomer"
              :disabled="imWebimSeatState == 'check'"
            >
              <el-option
                label="是"
                :value="1"
              ></el-option>
              <el-option
                label="否"
                :value="0"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="排序"
            prop="sort"
          >
            <el-input
              size="small"
              style="width: 177px;"
              v-model="imWebimSeat.sort"
              :disabled="imWebimSeatState == 'check'"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>

      <div
        slot="footer"
        class="flex justify-end"
      >
        <el-button @click="closeDialog">关闭</el-button>
        <el-button
          type="primary"
          @click="submitForm"
          v-if="imWebimSeatState != 'check'"
        >确定</el-button>
      </div>
    </el-dialog>
  </div>
  </div>
</template>

<script>
import { ArrowDownload24Regular, ArrowExportUp24Regular } from '@v2icons/fluent';
import { GridDots, Refresh, Printer, ArrowUp, ArrowDown, Search } from '@v2icons/tabler';
import { Edit24Regular, Delete24Regular, Eye24Regular } from '@v2icons/fluent';
import { exprotExcel, importTemplate, importDate, get, post, put, deleteFun } from '@/utils/request.js';
import { CUSTOMER, CUSTOMER_SEARCH, USER, USER_SEARCH } from '@/utils/constant.js';
import GridSelectU from '@/components/gridselect';
export default {
    components: {
        Edit24Regular,
        Delete24Regular,
        Eye24Regular,
        GridDots,
        Refresh,
        Printer,
        ArrowUp,
        ArrowDown,
        ArrowDownload24Regular,
        ArrowExportUp24Regular,
        Search,
        GridSelectU
    },
        watch: {
            checkState(val) {
                if (val == 'check') {
                    this.resetImWebimSeatList();
                    this.getImWebimSeatList(this.queryForm);
                    this.$emit('resetCheckState');
                } else if (val == 'reset') {
                    this.resetImWebimSeatList();
                    this.getImWebimSeatList();
                    this.$emit('resetCheckState');
                }
            }
        },
    data() {
            return {
                USER_code: USER,
                USER_search: USER_SEARCH,
                CUSTOMER_code: CUSTOMER,
                CUSTOMER_search: CUSTOMER_SEARCH,
                queryForm:{
                     id: '', //ID
                     customerId: '', //客服
                     userId: '', //坐席用户
                     greeting: '', //问候语
                     aiCustomer: '', //0 人工客服 1 智能客服
                     sort: '', //排序
                },
                loading: false,
                showDialog: false,
                isImportDate: false,
                isSearch: false,
                pageSize: 10,
                currentPage: 1,
                totalNum: 0,
                currentUserId: '',
                imWebimSeatState: 'add',
                imWebimSeatStates: {
                    add: '新建坐席',
                    check: '查看坐席',
                    edit: '修改坐席'
                },

                multipleSelection: [],
                imWebimSeatList: [],
                imWebimSeat: {
                    id: '', //ID
                    customerId: '', //客服
                    userId: '', //坐席用户
                    greeting: '', //问候语
                    aiCustomer: 0, //0 人工客服 1 智能客服
                    sort: '', //排序
                    createTime: '', //
                },
                btnLoading: false,
                isSa:'',
                rules: {
                    id: [{ required: true, message: 'ID不能为空', trigger: 'blur' }],
                    customerId: [{ required: true, message: '客服不能为空', trigger: 'blur' }],
                    userId: [{ required: true, message: '坐席用户不能为空', trigger: 'blur' }],
                    greeting: [{ required: true, message: '问候语不能为空', trigger: 'blur' }],
                    aiCustomer: [{ required: true, message: '0 人工客服 1 智能客服不能为空', trigger: 'blur' }],
                    sort: [{ required: true, message: '排序不能为空', trigger: 'blur' }],
                    createTime: [{ required: true, message: '不能为空', trigger: 'blur' }],
                }
            };
        },
        created() {
            this.getImWebimSeatList();
            this.getIsSa()
        },
        methods: {
            getIsSa(){
              get('/mpp/user/getIsSa').then(res=>{
                if(res.success){
                  this.isSa=res.isSa;
                }
              })
            },
            getValueUser1(value){
              this.imWebimSeat.userId = value
            },
            getValueUser(value) {
              this.imWebimSeat.customerId = value
            },
            getSearchValueUser(value) {
                this.queryForm.customerId = value
            },
            getSearchValueUser1(value){
                this.queryForm.userId = value
            },
            search(){
                this.isSearch = !this.isSearch;
            },
            resetImWebimSeatList() {
                this.pageSize = 10;
                this.currentPage = 1;
                this.imWebimSeatList = [];
            },
            resetDialog() {
                this.imWebimSeatState = 'add';
                this.showDialog = false;
                this.queryForm = {
                      id: '', //ID
                      customerId: '', //客服
                      userId: '', //坐席用户
                      greeting: '', //问候语
                      aiCustomer: '', //0 人工客服 1 智能客服
                      sort: '', //排序
                };
                this.getImWebimSeatList();
            },
            closeDialog() {
                this.showDialog = false
                this.imWebimSeat = {
                      id: '', //ID
                      customerId: '', //客服
                      userId: '', //坐席用户
                      greeting: '', //问候语
                      aiCustomer: 0, //0 人工客服 1 智能客服
                      sort: '', //排序
                      createTime: '', //
                };
            },
            submitForm() {
                if (this.imWebimSeatState == 'add') {
                    this.$refs.imWebimSeatForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimseat/add`,{ ...this.imWebimSeat }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000,
                                    });
                                    this.resetImWebimSeatList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                } else if (this.imWebimSeatState == 'edit') {
                    this.$refs.imWebimSeatForm.validate((valid) => {
                        if (valid) {
                            console.log('submit');
                            post(`/im/webimseat/edit`,{ ...this.imWebimSeat }).then((res) => {
                                if (res.success) {
                                    this.$message({
                                        message: res.msg,
                                        type: 'success',
                                        duration: 2000
                                    });
                                    this.resetImWebimSeatList();
                                    this.resetDialog();
                                } else {
                                    this.$message({
                                        message: res.msg,
                                        type: 'error',
                                        duration: 2000
                                    });
                                }
                            });
                        }
                    });
                }
            },
            addImWebimSeat() {
                this.showDialog = true;
                this.imWebimSeatState = 'add';
            },
            checkImWebimSeat(imWebimSeatId) {
                console.log(imWebimSeatId);
                this.currentImWebimSeatId = imWebimSeatId;

                this.getImWebimSeatById();
                this.showDialog = true;
                this.imWebimSeatState = 'check';
            },
            editImWebimSeat(imWebimSeatId) {
                console.log('imWebimSeat', imWebimSeatId);
                if (imWebimSeatId) {
                    this.currentImWebimSeatId = imWebimSeatId;
                    this.getImWebimSeatById();
                } else {
                    this.imWebimSeat = { ...this.imWebimSeat, ...this.multipleSelection[0] };
                }

                this.showDialog = true;
                this.imWebimSeatState = 'edit';
            },
            deleteImWebimSeat(imWebimSeatId) {
                let ids = '';
                if (imWebimSeatId) {
                    ids = imWebimSeatId;
                } else {
                    ids = this.multipleSelection.map((imWebimSeat) => imWebimSeat.id).join(',');
                }
                console.log({ ids });
                this.$confirm('确定删除所选项吗？', '提示', {
                    type: 'warning'
                })
                    .then(() => {
                        deleteFun(`/im/webimseat/delete`,{ ids }).then((res) => {
                            if (res.success) {
                                this.$message({
                                    message: res.msg,
                                    type: 'success',
                                    duration: 2000
                                });
                                this.resetImWebimSeatList();
                                this.getImWebimSeatList();
                            } else {
                                this.$message({
                                    message: res.msg,
                                    type: 'error',
                                    duration: 2000
                                });
                            }
                        });
                    })
                    .catch(() => {});
            },
            refreshImWebimSeatList() {
                this.resetImWebimSeatList();
                this.getImWebimSeatList();
            },
            getImWebimSeatList(query = {}) {
                this.loading = true;
                get(`/im/webimseat/findList`,{  ...this.queryForm, pageNum: this.currentPage, pageSize: this.pageSize }).then((res) => {
                    this.loading = false;
                    if (res.success) {
                        this.imWebimSeatList = res.page.list;
                        this.totalNum = res.page.total;
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            getImWebimSeatById() {
                get(`/im/webimseat/get`,{ id: this.currentImWebimSeatId }).then((res) =>{
                    if(res.success){
                      this.imWebimSeat = { ...this.imWebimSeat, ...res.imWebimSeat };
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                            duration: 2000
                        });
                    }
                });
            },
            /**
             * 导出信息
             */
            exportImWebimSeatList() {
                //this.btnLoading = true;
                exprotExcel(`/im/webimseat/export`, {...this.queryForm});
            },
            /**
             * 导出模板
             */
            importTemplate() {
                this.btnLoading = true;
                importTemplate(`/im/webimseat/importTemplate`, this.btnLoading);
            },
            /**
             * 导入数据
             */
            isImport() {
                this.isImportDate = !this.isImportDate;
            },
            upload(params){
              const file = params.file;
              const formData = new FormData();
              formData.append('file', file);
              console.log({ formData });
              importDate(`/im/webimseat/importData`,formData);
              this.refreshImWebimSeatList();
            },
            handleSelectionChange(value) {
                console.log(value);
                this.multipleSelection = value;
            },
            currentChange(page) {
                this.currentPage = page;
                this.getImWebimSeatList();
            },
            sizeChange(size) {
                this.pageSize = size;
                this.getImWebimSeatList();
            }
        }

};
</script>

<style lang="scss" scoped>
::v-deep .el-dialog__header {
    border-bottom: 1px solid #eee;
}
.operation {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #409eff;
    font-size: 12px;

    & > div {
        display: flex;
        align-items: center;
        padding: 0 5px;
        cursor: pointer;
    }

    .operation-label {
        margin-left: 3px;
    }
}
</style>